const config = {
  nftGalleryList: [
    {
      author: "",
      authorImage: null,
      fileName: "common.jpg"
    },
    {
      author: "",
      authorImage: null,
      fileName: "viperunique.jpg"
    },
    {
      author: "",
      authorImage: null,
      fileName: "viperepic.jpg"
    },
    {
      author: "",
      authorImage: null,
      fileName: "viperrare.jpg"
    },
    {
      author: "",
      authorImage: null,
      fileName: "legendary.jpg"
    },
  ],
  aboutOurNftsList: [{
    title: "Legendary",
    author: null,
    authorImage: "",
    description: `
    Inspired by Asian culture, this artistic work portrays a small boat sailing in harmony under a bridge, symbolizing the transition from old to new, towards a bright future of peace and harmony - making it the perfect Legendary NFT. Owning 2 different seasonal Legendary NFTs will grant you an entry ticket to the grand finale raffle, winning 100,000 COTI. Owning 3 different seasonal Legendary NFTs will give you an entry ticket to the grand final raffle, winning 250,000 COTI. Owning 4 of the seasonal Legendary NFTs will give you an entry ticket to the grand final raffle, winning 1,000,000 COTI. We are distributing a total of 320 Legendary NFTs, 20 every week.
    `,
    fileData: {
      fileName: "legendary.jpg"
    },
  },
  {
    title: "Viper",
    author: null,
    authorImage: "",
    description: ` 
      Inspired by the Chinese Da Shuhua Festival and the power of nature, this artistic work depicts a majestic viper and a fierce warrior. This powerful scene symbolizes immortality, fortune and prosperity - much like COTI Pay Wallet, therefore named VIPER. The Viper NFT series includes 3 special NFTs - Rare, Unique, and Epic. Holding the 3 NFTs will give you an entry to the seasonal raffle along with a chance to win 52,000 COTI. We are distributing a total of 2,720 VIPER NFTs: 100 Rare, 50 Unique, 20 Epic, every week.
    `,
    fileData: {
      fileName: "viperepic.jpg",
    },
  },
  {
    title: "Common",
    author: null,
    authorImage: "",
    description: `
      Inspired by the Chinese Da Shuhua Festival. This artistic work illustrates a peaceful scene of a fisherman on a boat at sunrise, while the sun shines over a pagoda. The winner of the Common NFT weekly raffle will also get 1,000 COTI, transferred directly into his VIPER wallet. We are distributing a total of 240 Common NFTs, 15 every week.
    `,
    fileData: {
      fileName: "common.jpg",
      // size: "3990x5000px",
      // dimensions: "13.9MB",
      // type: "JPG",
      // createTime: Date.now()
    },
  }],
  tableRowOptionTypes: ["copy", "copy", undefined, undefined, "nft-type"],
  nftsLabels: {
    "viperepic": "VIPER EPIC",
    "viperrare": "VIPER RARE",
    "viperunique": "VIPER UNIQUE",
  },
  nftsPath: {
    "legendary": "legendary.jpg",
    " viper epic": "viperepic.jpg",
    "viperepic": "viperepic.jpg",
    "viper epic": "viperepic.jpg",
    " viper unique": "viperunique.png",
    "viperunique": "viperunique.jpg",
    "viper unique": "viperunique.jpg",
    "viperrare": "viperrare.jpg",
    "viper rare": "viperrare.jpg",
    " viper rare": "viperrare.jpg",
    "common": "common.jpg"
  },
  nftTableHeaders: {
    "eth_address": "ETH Address",
    "coti_address": "COTI Address",
    "season": "Season",
    "raffle_id": "Raffle #",
    "nft_won": "NFT Won"
  }
}

export default config;